import { render, staticRenderFns } from "./classOpenServiceOne2.vue?vue&type=template&id=47f0ce70&"
import script from "./classOpenServiceOne2.vue?vue&type=script&lang=ts&"
export * from "./classOpenServiceOne2.vue?vue&type=script&lang=ts&"
import style0 from "./classOpenServiceOne2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports